import { Pipe, PipeTransform } from "@angular/core";
import { obtenerNombrePreguntaTipo, PreguntasTipoEnum } from "@shared/enums";

@Pipe({
    name: "nombreTipoPregunta"
})
export class NombreTipoPreguntaPipe implements PipeTransform {

    transform(tipo: PreguntasTipoEnum): string {
        return obtenerNombrePreguntaTipo(tipo);
    }

}
